import { ActionReducerMap } from '@ngrx/store';
import { TaxViewColumnViewModelStates } from '../states';
import * as fromColumn1ViewModelReducers from './column_1_view_model.reducers';
export const columnViewModelFeatureKey3 = 'genericDocTaxViewModel';
export const columnViewModelReducers3: ActionReducerMap<TaxViewColumnViewModelStates> = {
  column1ViewModel: fromColumn1ViewModelReducers.reducer,
};